import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type UpsertSupplierContactPayload } from '../types';
import {
  zodSupplierContactSchema,
  zodUpsertSupplierContactPayloadSchema,
} from '../validations';

/**
 * Updates an existing contact for a supplier relationship.
 *
 * Replaces the full person (name, email, phone) and reconciles the role set
 * to exactly the roles supplied. The person id is preserved.
 *
 * @param deId - The data exchange ID of the supplier relationship.
 * @param contactId - The stable person id of the contact to update.
 * @param payload - The full person body with the complete new role set.
 * @param options - Optional ky request options (e.g., abort signal).
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/update_supplier_contact_suppliers__de_id__contacts__contact_identity_id__patch
 */
export const updateSupplierContact = async (
  deId: UUID,
  contactId: UUID,
  payload: UpsertSupplierContactPayload,
  options?: KyRequestOptions,
) => {
  await vestigasApi
    .patch(ENDPOINT.SUPPLIER.UPDATE_CONTACT(deId, contactId), {
      ...options,
      json: payload,
      validate: {
        body: zodUpsertSupplierContactPayloadSchema,
        response: zodSupplierContactSchema,
      },
    })
    .json();
};
